import ContinueButton from "@components/common/ContinueButton";
import CounterInput from "@components/common/CounterInput";
import ExitButton from "@components/icons/ExitButton";
import { COUNT, TYPE } from "@customTypes/index";
import useModalScrollFreeze from "@hooks/useModalScrollFreeze";
import useCountInput, { CountAction, CountType } from "hooks/useCountInput";
import { useCallback, useEffect } from "react";
import BackButton from "../../icons/BackButton";
import MultiRangePrice from "./MultiRangePrice";

interface ISpecificsProps {
  onClick: (isOpen: boolean, isSuccessMobile?: boolean | undefined) => void;
  onBackClick: (isOpen: boolean) => void;
  onRequestOpen: (isOpen: boolean) => void;
}

const Specifics = ({
  onClick,
  onBackClick,
  onRequestOpen,
}: ISpecificsProps): JSX.Element => {
  const {
    numberOfAdult,
    numberOfTeen,
    numberOfChildren,
    setNumberOfAdult,
    setNumberOfTeen,
    setNumberOfChildren,
    handleTypeCount,
  } = useCountInput();

  const onIncrementClick = useCallback(
    (count: CountAction, type: CountType) => {
      handleTypeCount(count, type);
    },
    [numberOfAdult, numberOfTeen, numberOfChildren]
  );
  const onDecrementClick = useCallback(
    (count: CountAction, type: CountType) => {
      handleTypeCount(count, type);
    },
    [numberOfAdult, numberOfTeen, numberOfChildren]
  );
  useModalScrollFreeze([true]);

  useEffect(() => {
    if (localStorage.getItem("USER_REQUEST_QUOTE")) {
      const { adults, teens, children } = JSON.parse(
        // @ts-expect-error
        localStorage.getItem("USER_REQUEST_QUOTE")
      ).travelers;

      setNumberOfAdult(adults);
      setNumberOfTeen(teens);
      setNumberOfChildren(children);
    }
  }, []);

  return (
    <div className="fixed left-0 top-0 right-0 z-[100] flex h-full w-full flex-col justify-between overflow-auto bg-white">
      <div className="absolute top-0 z-[60] h-screen w-full overflow-hidden bg-white scrollbar-hide">
        <div className="mx-auto h-full w-[90%]">
          <div className="mt-3 flex items-center justify-between">
            <div>
              <BackButton onClick={() => onBackClick(false)} />
            </div>
            <div className="font-medium">Request a Custom Quote</div>
            <div>
              <ExitButton onClick={onRequestOpen} />
            </div>
          </div>
          <div className="mt-3 mb-3 flex items-center justify-center">
            <div className="text-p14 text-midgray">Step 2 of 3</div>
            <div className="mx-3 inline-block h-4 w-[0.2px] bg-blue-20"></div>
            <div className="text-p14 text-midgray">Request a Custom Quote</div>
          </div>
          <div className="flex">
            <h3 className="mb-[6px] font-medium text-darkgray">
              Number of Travelers
            </h3>
          </div>
          <div className="mb-6 flex justify-between">
            <div className="flex flex-col">
              <div className="mb-[0.5] font-medium">Adults</div>
              <div className="text-p13 font-medium text-midgray">
                Ages 18 and above
              </div>
            </div>
            <CounterInput
              value={numberOfAdult}
              onIncrementClick={() =>
                onIncrementClick(COUNT.increment, TYPE.adult)
              }
              onDecrementClick={() =>
                onDecrementClick(COUNT.decrement, TYPE.adult)
              }
            />
          </div>
          <div className="mb-6 flex justify-between">
            <div className="flex flex-col">
              <div className="mb-[0.5] font-medium">Teens</div>
              <div className="text-p13 font-medium text-midgray">
                Ages 12 to 17
              </div>
            </div>
            <CounterInput
              value={numberOfTeen}
              onIncrementClick={() =>
                onIncrementClick(COUNT.increment, TYPE.teen)
              }
              onDecrementClick={() =>
                onDecrementClick(COUNT.decrement, TYPE.teen)
              }
            />
          </div>
          <div className="mb-6 flex justify-between">
            <div className="flex flex-col">
              <div className="mb-[0.5] font-medium">Children</div>
              <div className="text-p13 font-medium text-midgray">Under 12</div>
            </div>
            <CounterInput
              value={numberOfChildren}
              onIncrementClick={() =>
                onIncrementClick(COUNT.increment, TYPE.children)
              }
              onDecrementClick={() =>
                onDecrementClick(COUNT.decrement, TYPE.children)
              }
            />
          </div>

          <div className="mt-8 mb-4 flex">
            <h3 className="mb-[6px] font-medium text-darkgray">
              Nightly budget
            </h3>
          </div>
          <MultiRangePrice />
        </div>
        <ContinueButton onClick={onClick} />
      </div>
    </div>
  );
};

export default Specifics;
